import { createSlice } from '@reduxjs/toolkit'
import { ClientLabelsSchema } from '../types/ClientLabelsSchema'
import { fetchClientLabels } from '../services/fetchClientLabels'
import { ClientLabelWithId } from '../../../../entities/ClientLabel'

const initialState: ClientLabelsSchema = {
	clientLabels: [],
	clientLabelsDict: {},
	clientLabelNameColorDict: {},
	isLoading: false,
	error: ''
}

const clientLabelsSlice = createSlice({
	name: 'clientLabelsSlice',
	initialState,
	reducers: {
		resetState: (state) => {
			state.clientLabels = []
		}
	},
	extraReducers: builder => {
		builder
			.addCase(fetchClientLabels.pending, (state) => {
				state.isLoading = true
				state.error = ''
			})
			.addCase(
				fetchClientLabels.fulfilled,
				(state, action) => {
					const clientLabels = action.payload
					state.clientLabels = clientLabels
					state.isLoading = false
					state.error = ''

					state.clientLabelsDict = clientLabels.reduce(
						(acc: Record<string, ClientLabelWithId>, label) => {
							acc[label.labelId] = label
							return acc
						}, {})

					state.clientLabelNameColorDict = clientLabels.reduce(
						(acc: Record<string, string>, label) => {
							acc[label.labelName] = label.labelColor
							return acc
						}, {})
				})
			.addCase(fetchClientLabels.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
	}
})

export const { actions: clientLabelsActions } = clientLabelsSlice
export const { reducer: clientLabelsReducer } = clientLabelsSlice
